import React, { useState } from "react";
import Layout from "../../Components/Layout";
import Styles from "./index.module.css";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import ReactLoading from "react-loading";
import { warningSwal } from "../../Util/Toast";
import Table from "./Table";
import moment from "moment";
import ReactPaginate from "react-paginate";

function TotalCustomerReport() {
    const { register, handleSubmit, formState: { errors }, reset, getValues } = useForm();
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(null);
    const [link, setLink] = useState("");
    const [totalStudents, setTotalStudents] = useState(null);
    const [totalRecords, setTotalRecords] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    const handleClear = () => {
        reset();
        setResults(null);
        setLink("");
        setTotalStudents(null);
        setTotalRecords(null);
        setPage(1);
        setTotalPages(0);
    };

    const onSubmit = async (data, pageNumber = 1) => {
        setLoading(true);
        try {
            const res = await Services.get_total_customers(
                "GET",
                null,
                token,
                data.FromDate,
                data.ToDate,
                data.DormantFromDate,
                data.DormantToDate,
                data.Status || "all",
                pageNumber,
                20
            );
            setLoading(false);
            if (res?.Status === 1) {
                setTotalStudents(res.TotalStudents);
                setTotalRecords(res.TotalRecords);
                setTotalPages(res.Pagination?.TotalPages || 0);
                setPage(res.Pagination?.CurrentPage || 1);
                setResults(
                    res.Results?.map((item) => ({
                        "Parent Full Name": item.ParentFullName || "NA",
                        "Student Full Name": item.StudentFullName || "NA",
                        "DOB": item.DOB && item.DOB !== "0000-00-00" ? moment(item.DOB).format("DD-MM-YYYY") : "NA",
                        "Primary Phone Number": item.PrimaryPhoneNumber || "NA",
                        "Secondary Phone Number": item.SecondaryPhoneNumber || "NA",
                        "Current Balance": item.CurrentBalance !== undefined && item.CurrentBalance !== null ? Number(item.CurrentBalance).toFixed(2) : "0.00",
                        "Address": [item.Address, item.City, item.State, item.Country, item.Pincode].filter(Boolean).join(", ") || "NA",
                        "Email ID": item.EmailID || "NA",
                        "Status": item.Status == 1 ? "Active" : item.Status == 2 ? "Dormant" : "NA",
                        "Customer Created Date": item.CustomerCreatedDate ? moment(item.CustomerCreatedDate).format("DD-MM-YYYY hh:mm A") : "NA",
                        "Dormant Date": item.DormantDate ? moment(item.DormantDate).format("DD-MM-YYYY hh:mm A") : "NA",
                    })) || []
                );
            } else {
                console.error(res);
                warningSwal("Warning", res?.message || "Failed to fetch report");
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
            warningSwal("Warning", "Something went wrong");
        }
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        setPage(selectedPage);
        const formData = getValues();
        onSubmit(formData, selectedPage);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const handleExport = async () => {
        const data = getValues();
        setLoading(true);
        try {
            const res = await Services.total_customer_report(
                "GET",
                null,
                token,
                data.FromDate,
                data.ToDate,
                data.DormantFromDate,
                data.DormantToDate,
                data.Status || "all"
            );
            setLoading(false);
            if (res?.Status === 1 && res.CsvFile) {
                window.open(res.CsvFile, "_blank");
            } else {
                console.error(res);
                warningSwal("Warning", res?.message || "Failed to generate export");
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
            warningSwal("Warning", "Something went wrong during export");
        }
    };

    return (
        <Layout Active={"Total Customer Report"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Total Customer Report</title>
            </Helmet>
            <div className={Styles["Container"]}>
                <div className={Styles["wrapper"]}>
                    <h3>Total Customer Report</h3>
                    <form onSubmit={handleSubmit((data) => onSubmit(data, 1))} style={{ flexWrap: "wrap", alignItems: "flex-start" }}>
                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '150px' }}>
                            <label>From Date</label>
                            <input type="date" {...register("FromDate")} />
                        </div>
                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '150px' }}>
                            <label>To Date</label>
                            <input type="date" {...register("ToDate")} />
                        </div>
                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '150px' }}>
                            <label>Dormant From Date</label>
                            <input type="date" {...register("DormantFromDate")} />
                        </div>
                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '150px' }}>
                            <label>Dormant To Date</label>
                            <input type="date" {...register("DormantToDate")} />
                        </div>

                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '150px' }}>
                            <label>Status</label>
                            <select {...register("Status")} defaultValue={"all"}>
                                <option value="all">All</option>
                                <option value="1">Active</option>
                                <option value="2">Dormant</option>
                            </select>
                        </div>

                        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", alignSelf: "flex-end" }}>
                            <button
                                type="submit"
                                disabled={loading}
                                className={`${Styles.btn} ${Styles.btnPrimary}`}
                                aria-busy={loading}>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                                    {loading && <ReactLoading type="spokes" color="#0077b6" height={14} width={14} />}
                                    {loading ? "Submitting..." : "Submit"}
                                </span>
                            </button>

                            <button
                                type="button"
                                className={Styles.btn}
                                style={{
                                    backgroundColor: "#f3f4f6",
                                    color: "#374151",
                                    border: "1px solid #d1d5db"
                                }}
                                onClick={handleClear}
                                disabled={loading}>
                                Clear
                            </button>

                            {results && (
                                <button
                                    type="button"
                                    className={`${Styles.btn} ${Styles.btnExport}`}
                                    onClick={handleExport}
                                    disabled={loading}>
                                    Export
                                </button>
                            )}
                        </div>
                    </form>

                    {results && (
                        <div style={{ overflow: "auto", marginTop: 16 }}>
                            {totalStudents !== null && totalStudents !== undefined && (
                                <div style={{ marginBottom: "10px", fontSize: "16px", fontWeight: "bold", color: "#0077b6" }}>
                                    Total Records: {totalRecords} | Total Students: {totalStudents}
                                </div>
                            )}
                            <Table
                                data={results}
                                emptyHeaders={[
                                    "Parent Full Name",
                                    "Student Full Name",
                                    "DOB",
                                    "Primary Phone Number",
                                    "Secondary Phone Number",
                                    "Current Balance",
                                    "Address",
                                    "Email ID",
                                    "Status",
                                    "Customer Created Date",
                                    "Dormant Date"
                                ]}
                                style={{ minWidth: "1800px" }}
                            />
                            {totalPages > 1 && (
                                <ReactPaginate
                                    previousLabel={"<"}
                                    nextLabel={">"}
                                    breakLabel={"..."}
                                    pageCount={totalPages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination"}
                                    activeClassName={"active"}
                                    forcePage={page - 1}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default TotalCustomerReport;
